@if (user$ | async; as user) {
  <div class="user-greeting">
    <span class="user-greeting-text">
      {{ 'cartAdministration.miniLogin.userGreeting' | cxTranslate: { name: user.name } }}
    </span>
    <cx-page-slot position="HeaderLinks"></cx-page-slot>
  </div>
} @else {
  <a role="link" [routerLink]="{ cxRoute: 'login' } | cxUrl">{{
    'cartAdministration.miniLogin.signInRegister' | cxTranslate
  }}</a>
}

